// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_base_printable__HyC1s","nonPrintable":"styles_base_nonPrintable__kBLk6","bottomLink":"styles_base_bottomLink__ICzvZ"};